import React from 'react';
import { Field } from 'redux-form';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Fields from 'components/Fields';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';
import wizard from 'consts/wizard';
import { useFormatMessage } from 'components/IntlProvider';

interface AgeProps {
  audienceAge: [number, number];
}

const Age = ({ audienceAge }: AgeProps) => {
  const classes = wizardStyles();
  const initialValue = audienceAge || wizard.AUDIENCE_AGE;
  const [defaultMin, defaultMax] = wizard.AUDIENCE_AGE;
  const [min, max] = initialValue;
  const t = useFormatMessage();

  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t('fields.wizard.age', 'Age from {min} to {max}', {
          min,
          max,
        })}
      </Typography>
      <Grid item xs={12} className={classes.slider}>
        <Field
          component={Fields.Slider}
          name="audience_age"
          min={defaultMin}
          max={defaultMax}
          step={1}
          initialValue={initialValue}
        />
      </Grid>
    </>
  );
};

export default Age;
